import { DeviceType } from '@/types/common';
import { isMobile } from 'is-mobile';

export const isMobileDevice = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < 700;
  }
  return isMobile();
};

export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
};
export const getDeviceType = () => {
  if (isMobileDevice()) {
    if (isAndroid()) {
      return DeviceType.ANDROID;
    }
    return DeviceType.IOS;
  }
  return DeviceType.WEB;
};

export const getCustomerCountry = () => {
  return navigator.language.split('-')[1];
};

export const isLandscape = () => {
  return (
    window.innerWidth > window.innerHeight &&
    window.innerWidth > 700 &&
    window.innerWidth <= 1023 &&
    window.innerHeight <= 500
  );
};
